/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

export default {
  apiGateway: {
    // URL: process.env.REACT_APP_BACKEND_URL
    URL: 'https://rtsm-backend-rd01.rd.signanthealth.com/edcf-backend/'
  },
  maxAdditionalContacts: process.env.REACT_APP_MAX_ADDITIONAL_CONTACTS || 2
};
